module.exports = __webpack_public_path__ + "static/media/hydroponics_systems_dutch_bucket1.2e400d4d.webp";